/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The validation status of given specification.
 */
export type ValidationStatus =
  (typeof ValidationStatus)[keyof typeof ValidationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidationStatus = {
  OPEN: "OPEN",
  VALID: "VALID",
  INVALID: "INVALID",
} as const;
